module.exports = __webpack_public_path__ + "img/faq-smartphone.17a4b7c0.svg";